export default class CaseInsureModel {
  constructor() {
    // 風險承擔費
    this.ExposuresCash = '';
    // 對保收現
    this.GuaranteeCash = '3500';
    // 實際對保費
    this.ActualGuaranteeCash = '1500';
    // 對外對保費
    this.ForeignGuarantee = '1500';
    // 前傭
    this.Commission = '';
    // 代刻印章
    this.EngravedSeal = '20';
  }
}



// WEBPACK FOOTER //
// ./src/models/CaseInsureModel.js